module.exports = __webpack_public_path__ + "img/v6.a589588f.jpg";